import React from 'react';
import PropTypes from 'prop-types';
import { DateTimeFormater, truncateText } from "../../../../services/Helper";

import NoteForm from '../../../../components/NoteForm';

const OrderNotes = ({ notes, orderId, setNotes }) => {
  return (
    <>
      {/* Notes List */}
      {notes?.length > 0 && (
        <div className="notes-list">
          {notes.map((note) => (
            <NoteCard key={note._id || note.id} note={note} />
          ))}
        </div>
      )}

      {/* Note Form */}
      <div className="card mt-4" style={{ background: "transparent" }}>
        <div className="card-body">
          <NoteForm id={orderId} setNotes={setNotes} notes={notes} />
        </div>
      </div>
    </>
  );
};

// Note Card Sub-component
const NoteCard = ({ note }) => (
  <div className="card note-card mt-4">
    <div className="card-body">
      <p className="m-0 p-0 note-title">
        {(note.title)}
      </p>
      <p className="m-0 p-0 note-date">
        {DateTimeFormater(note.createdAt)}
      </p>
      <p className="m-0 p-0 note-body">
        {note.description}
      </p>
    </div>
  </div>
);

// Prop Types
OrderNotes.propTypes = {
  notes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      _id: PropTypes.string,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      createdAt: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired
    })
  ),
  orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setNotes: PropTypes.func.isRequired
};

NoteCard.propTypes = {
  note: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    createdAt: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired
  }).isRequired
};

export default OrderNotes;